export default "__VITE_ASSET__QMVAw8Y7__"